// @flow

import * as React from 'react';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import PageTransition from '~/components/routing/page-transition';

import { AnimatedContentContainer, AnimatedContent } from './styles';

type Props = {
    transitionKey: string,
    children: React.Node
};

const LoadTransition = ({ transitionKey, children }: Props) => (
    <TransitionGroup>
        <PageTransition key={transitionKey}>
            <AnimatedContentContainer>
                <AnimatedContent>{children}</AnimatedContent>
            </AnimatedContentContainer>
        </PageTransition>
    </TransitionGroup>
);

export default LoadTransition;



// WEBPACK FOOTER //
// ./src/components/widgets/load-transition/index.js